module.exports = __webpack_public_path__ + "static/media/Arial black-01.354dcd59.svg";